import 'intersection-observer';
import * as basicScroll from 'basicscroll';
import { circlesFactory } from './circles';

// Appear animations

const handleIntersected = (nodeArr = []) => {
    nodeArr.forEach((node) => {
        node.classList.add('show');
        node.classList.remove('hide');
    });
};

const createObs = (animElements = []) => {
    const obs = new IntersectionObserver((entries) => {
        const intersectedEntries = entries.filter(({ isIntersecting }) => isIntersecting === true);

        if (intersectedEntries.length > 0) {
            const intersectedNodes = intersectedEntries.map(({ target }) => target);

            handleIntersected(intersectedNodes);
            intersectedNodes.forEach((node) => obs.unobserve(node));
        }
    }, {
        threshold: 0.4
    });

    animElements.forEach((node) => {
        node.classList.add('hide');
        obs.observe(node);
    });
};

export const initAppearAnimation = () => {
    const animElements = [...document.querySelectorAll('[data-animate]')];

    if (animElements.length > 0) createObs(animElements);
};

// Scroll animations

const registerBasicScrollInstance = (elem = null, props = {}) => basicScroll.create({
    elem,
    props,
    from: 'top-bottom',
    to: 'bottom-top',
    direct: true
});

export const initScrollAnimation = (isMobile = false) => {
    const marqueeNode = document.querySelector('.intro__marquee>span');
    const marquee = registerBasicScrollInstance(marqueeNode, {
        '--marquee-tx': isMobile ? {
            from: '4%',
            to: '-32.5%'
        } : {
            from: '6%',
            to: '-52.5%'
        }
    });
    const introIllnNode = document.querySelector('section.section .intro__twocol .column--left .svg-wrap');
    const introIlln = registerBasicScrollInstance(introIllnNode, {
        '--girl-transform': {
            from: '0',
            to: '-50px'
        },
        '--mask-scale': {
            from: '1',
            to: '1.15'
        }
    });
    const prlxIllnsNodeList = [...document.querySelectorAll('.prlx[data-shift]')];
    const prlxIllns = prlxIllnsNodeList.map((node) => {
        const { shift = 1 } = node.dataset;
        const finShift = parseFloat(shift);

        return registerBasicScrollInstance(node, {
            '--prlx': {
                from: `${finShift * 80}px`,
                to: `${finShift * -10}px`
            }
        });
    });
    const sectionsNodeList = [...document.querySelectorAll('section.section')];
    const sectionCircles = sectionsNodeList.map((node) => registerBasicScrollInstance(node, {
        '--section-circle-ty': isMobile ? {
            from: '200px',
            to: '-200px'
        } : {
            from: '400px',
            to: '-400px'
        }
    }));

    sectionsNodeList.forEach((section) => circlesFactory(section, isMobile));

    marquee.start();
    introIlln.start();
    prlxIllns.forEach((bs) => bs.start());
    sectionCircles.forEach((bs) => bs.start());
};
